export const sortByLastName = (a, b) => {
  if (!a.name || !b.name) {
    return 0;
  } else {
    // Split each name into first and last names
    const lastNameA = a.name.split(" ").pop();
    const lastNameB = b.name.split(" ").pop();

    // Compare the last names
    if (lastNameA < lastNameB) return -1;
    if (lastNameA > lastNameB) return 1;
  }
};
